import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import store from './store'
import App from './App'
import * as auth from './services/OnBoarding/auth'
import { REDIRECT_TO_V2_APP } from './api_urls'
import './styles/main.css'

// v1 only still owns a handful of routes; everything else lives in v2.
//
// This gate has to run before React mounts. When the redirect lived in a
// catch-all <Route> it was queued during render, and App's own effects then
// ran before the browser acted on it — a 401 from useSentry's getUser() call
// hit the interceptor in services/api.jsx, which clears storage and calls
// window.location.reload(). The reload superseded the pending cross-origin
// navigation and wiped the storage that would have prevented the next 401,
// so app.cleverclinic.co.uk sat in an infinite reload loop instead of
// redirecting. Nothing can race us from here.
const { pathname } = window.location

const isUnder = base => pathname === base || pathname.startsWith(`${base}/`)

// Accepting an invite always ends up in v2; v1 just drops the stale session
// on the way through.
const isInviteAccept = isUnder('/clinics/invite/accept')

const shouldRenderV1 =
  isUnder('/remoteAuthRedirect') ||
  (isUnder('/clinics') && !isInviteAccept && auth.isLoggedIn() !== null)

if (shouldRenderV1) {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <Provider store={store}>
      <App />
    </Provider>,
  )
} else {
  if (isInviteAccept) {
    localStorage.clear()
    sessionStorage.clear()
  }
  window.location.replace(REDIRECT_TO_V2_APP)
}
